var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#6978F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4975 24.1472C28.128 24.1472 31.0711 21.2041 31.0711 17.5736C31.0711 13.9431 28.128 11 24.4975 11C20.8669 11 17.9238 13.9431 17.9238 17.5736C17.9238 21.2041 20.8669 24.1472 24.4975 24.1472Z",
    fill: "#CED3FE",
    stroke: "#CED3FE",
    strokeWidth: 0.801992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37.2981C36.1508 34.6502 34.4828 32.3403 32.2362 30.7015C29.9897 29.0627 27.2808 28.1797 24.5 28.1797C21.7192 28.1797 19.0103 29.0627 16.7638 30.7015C14.5172 32.3403 12.8492 34.6502 12 37.2981H37Z",
    fill: "#CED3FE",
    stroke: "#CED3FE",
    strokeWidth: 0.801992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user-default.0e4e1a70f7f2a9930c78db9a4287e0cf.svg";
export { ForwardRef as ReactComponent };